import React from 'react';

// Utils
import PageUrlUtils from 'Shared/utils/PageUrls.utils';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpButton } from 'Wpds/components/button';
import WpTextField from 'Wpds/components/text-field/WpTextField';

// Styles
import './ShareReportModal.scss';

type Props = {
  slug: string;
  isOpen: boolean;
  toggleIsOpen: () => void;
};

const ShareReportModal = ({ slug, isOpen, toggleIsOpen }: Props) => {
  if (!isOpen) return null;

  const link = `${window.location.origin}${PageUrlUtils.makeUpdateAiRportPageUrl({ slug })}`;

  const baseClassName = 'ShareReportModal';
  return (
    <WpModal isOpen={isOpen} onToggle={toggleIsOpen} size="sm" innerClassName={baseClassName}>
      <WpModalHeader onToggle={toggleIsOpen}>Share</WpModalHeader>
      <WpModalBody>
        <WpContainer className={`${baseClassName}__container`}>
          <WpContainerBody>
            <p className={`${baseClassName}__container__title`}>Share with Link</p>
            <p className={`${baseClassName}__container__description`}>
              Anyone with this link will be able to view the update.
            </p>
            <div className={`${baseClassName}__container__body`}>
              <WpTextField
                id="report-share-link"
                label="Share link"
                value={link}
                enableCopy
                disabled
                labelHidden
                // onCopy={onCopyLink}
              />
            </div>
          </WpContainerBody>
        </WpContainer>
      </WpModalBody>
      <WpModalFooter>
        <WpButton onClick={toggleIsOpen} variant="tertiary">
          Close
        </WpButton>
      </WpModalFooter>
    </WpModal>
  );
};

export default ShareReportModal;
